
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[franchiseeSlug]/careers",
      function () {
        return require("private-next-pages/[franchiseeSlug]/careers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[franchiseeSlug]/careers"])
      });
    }
  